<template>
  <el-dialog 
    custom-class="update-username-dialog"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    title="修改总部管理员用户名">

    <el-form v-if="updating" :model="form" :rules="rule" label-width="200px" ref="form" class="update-name-form" @keyup.native.enter="handleSave">
      
      <el-form-item label="当前总部管理员用户名">
        <span>{{this.userInfo.username}}</span>
      </el-form-item>
      <el-form-item label="当前登录密码" prop="password">
        <el-input type="password"  :maxlength="20"  v-model="form.password"></el-input>
      </el-form-item>
      <el-form-item label="新的总部管理员用户名" prop="newUserName">
        <el-input type="text" v-model.trim="form.newUserName"></el-input>
      </el-form-item>
      <el-form-item label="确认新的总部管理员用户名" prop="confirmUserName">
        <el-input type="text" v-model.trim="form.confirmUserName"></el-input>
      </el-form-item>
      <el-form-item label="验证码" class="sm-input" prop="captcha">
            <el-input type="text" v-model="form.captcha" placeholder="验证码" prefix-icon="iconfont icon-yanzhengma" :maxlength="4" ref="captcha"></el-input>
            <img class="img-captcha" :src="`/metis-login-web/captcha?captchaKey=${form.captchaKey}`"/>
            <span class="refresh-btn" @click="refresh">刷新</span>
          </el-form-item>
      <div class="footer-btns">
        <el-button :disabled="disabled" type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-form>
    <div class="update-result" v-else>
       <p>恭喜您，修改成功！</p> 
       <p>您的集团号：{{this.userInfo.agencyId}} </p> 
       <p>新的总部管理员用户名： <span class="new-user-name">{{this.form.newUserName}}</span></p> 
       <p>请牢记以上信息</p> 
       <p>已向该账号的绑定手机 {{userInfo.mobile | encrypt('phone')}} 发送备忘短信，如您的手机号已更换，可在重新登录后通过【绑定手机号】更改</p> 
       <el-button class="retry-login" type="primary" :disabled="reLoginDisabled" @click="relogin">{{reloginBtn}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  const repeatUserName = []; //为什么不在data里定义呢

  import {mapState} from 'vuex';
  import { lxCidTracker } from '@util/lxTracker';
  export default {
    computed: {
      ...mapState(['userInfo'])
    },
    data () {
      let checkPassword = (rule, value, callback) => {
        value = value.trim();
        if (!/^[a-zA-Z0-9\w~!@#$%^&*.?\s]*$/.test(value)) {
          return callback(new Error('密码错误'));
        } else {
          return callback();
        }
      };
      let checkUserName = (rule, value, callback) => {
        value = value.trim();
     
        if (/^\d{11}$/.test(value)) {
          return callback(new Error('用户名不能是11位数字'));
        } else if (!/^[a-zA-Z0-9]*$/.test(value)) {
          return callback(new Error('用户名必须由数字和/或英文字母组成'));
        } else {
         
          // 校验用户名是否存在
          if (repeatUserName.indexOf(value) !== -1) {
            return callback(new Error('用户名已存在，请尝试其他用户名'));
          }
          this.$axios.get(`/metis-user-web/check/register/name/1/${value.toLowerCase()}`).then((res) => {
            if (res.code === 200) {
              if (res.data === 1) {
                repeatUserName.push(value);
                return callback(new Error('用户名已存在，请尝试其他用户名'));
              } else if (res.data === 0) {
                callback();
              }
            }
          });
        }
      };
      let checkConfirmName = (rule, value, callback) => {
        if (value !== this.form.newUserName) {
          return callback(new Error('两次输入的新用户名不一致'));
        } else {
          callback();
        }
      };
      let checkCaptcha = (rule, value, callback) => {
        if (!/^[a-zA-Z0-9]*$/.test(value)) {
          return callback('验证码错误');
        } else {
          callback();
        }
      };
  
      return {
        visible: false,
        updating: true,
        disabled: false,
        reLoginDisabled: true,
        reloginBtn: '重新登录',
        form: {
          password: '',
          newUserName: '',
          confirmUserName: '',
          captcha: '',
          captchaKey: ''
        },
        rule: {
          password: [
            {required: true, message: '请输入登录密码', trigger: 'blur'},
            {validator: checkPassword, trigger: 'blur'}
          ],
          newUserName: [
            {required: true, message: '请输入新的总部管理员用户名', trigger: 'blur'},
            { min: 4, max: 32, message: '长度在 4 到 32 个字符', trigger: 'blur' },
            {validator: checkUserName, trigger: 'blur'}
          ],
          confirmUserName: [
            {required: true, message: '请再次输入新的总部管理员用户名', trigger: 'blur'},
            {validator: checkConfirmName, trigger: 'blur'}
          ],
          captcha: [
            {required: true, message: '请输入验证码', trigger: 'blur'},
            {validator: checkCaptcha, trigger: 'blur'}
          ]
        }
      };
    },
    methods: {
      show () {
        this.visible = true;
        lxCidTracker({ meta: { cid: 'c_eco_k6x4z1eh'}});
        this.refresh();
      },
      refresh () {
        this.form.captchaKey = String(Date.now()).substr(-5) + Math.random().toString(36).substr(2);
      },
      handleSave () {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let params = {
              userName: String.trim(this.userInfo.username),
              password: this.form.password,
              newUserName: String.trim(this.form.newUserName),
              validateCode: String.trim(this.form.captcha),
              captchaKey: this.form.captchaKey
            };
            this.disabled = true;
            this.$axios.post('/metis-user-web/user/modifyUserName', this.$qs.stringify(params)).then(res => {
              
              this.disabled = false;
              if (res.code === 200) {
                this.updating = false;
                lxCidTracker({ meta: { cid: 'c_eco_780z2s20'}});
                let time = 10;
                let intervalId = null;
                this.reloginBtn = `${time}s`;
                intervalId = setInterval(() => {
                  time--;
                  this.reloginBtn = `${time}s`;
                  if (time === 0) {
                    clearInterval(intervalId);
                    this.reloginBtn = '重新登录';
                    this.reLoginDisabled = false;
                  }
                }, 1000);


              } else if (res.code === 514) {
                this.$message({
                  message: '验证码错误',
                  type: 'error'
                });
                this.refresh();
                this.form.captcha = '';
              } else if (res.code === 2003) {
                this.$message({
                  message: '密码错误',
                  type: 'error'
                });
                this.refresh();
                this.form.captcha = '';
              } else {
                this.$message({
                  message: res.message,
                  type: 'error'
                });
                //this.$message.error(res.errors);
              }
              
            }).catch(res => {
              console.log("catch", res);
              this.$message.error('系统繁忙，请稍后重试');
            });
          }
        });
      },
      relogin () {
        localStorage.removeItem('agency_tree');
        localStorage.removeItem('showMTRights');
        localStorage.removeItem('storeRightsMenu');
        localStorage.removeItem('storeRightsDialog');
        localStorage.removeItem('weakPwd');
        localStorage.removeItem('menu');
        localStorage.removeItem('menuList');
        window.location.href=`/account-web/#/${this.userInfo.belongId}/${this.form.newUserName}`;
      }
    }
  };
</script>

<style lang="less">
  .update-username-dialog {

    .update-name-form {
      padding: 0 120px 0 100px;
      .el-form-item__label {
        padding-right: 30px;
      }
      .sm-input {
        .el-input {
          width: 164px;
        }
      }
      .img-captcha {
        height: 34px;
        border-radius: 4px;
        margin: 0 6px;
        vertical-align: middle;
      }
      .footer-btns {
        margin-top: 30px;
        text-align: center;
      }
    }
    .update-result {
      .new-user-name {
        color: red;
      }
      .retry-login {
        display: block;
        margin: 40px auto 20px; 
      }
    }    
  }

</style>



// WEBPACK FOOTER //
// UpdateName.vue?35b900bd